import type { AppEnvClient } from './types';

let _appEnvClient: AppEnvClient | null = null;

export function setAppEnvClient(client: AppEnvClient | null): void {
	_appEnvClient = client;
}

export function getAppEnvClient(): AppEnvClient | null {
	return _appEnvClient;
}
